module.exports = __webpack_public_path__ + "img/audio.3bbbdec6.png";